import React from 'react';

import DashboardFormHeader from 'components/DashboardFormHeader';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import { maskMonetaryValue } from 'prequalificationV2/utils/stringUtils';
import { getBorrowerNames } from 'prequalificationV2/pages/PreQualification/steps/AcceptOffer/AutomatedOffers/acceptAutomatedOffer.utils';

import styles from './DashboardOfferHeader.module.scss';

const DashboardOfferHeader = ({
  borrowerFirstName,
  coBorrowerFirstName,
  maxLoanAmount,
}: {
  borrowerFirstName: string;
  coBorrowerFirstName?: string | null;
  maxLoanAmount: number;
}) => {
  return (
    <DashboardFormHeader
      mainMessage={
        <>
          <div>{getBorrowerNames(borrowerFirstName, coBorrowerFirstName)},</div>
          <div>
            You qualify for offers up to{' '}
            <span className={styles.titleSecondPart}>{maskMonetaryValue(maxLoanAmount)}</span>.
          </div>
        </>
      }
      percent={ProgressBarStatus.Done}
      isDefaultStyles
    />
  );
};

export default DashboardOfferHeader;
